exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".list-item[data-v-614be14b]{border:1px solid #ededed;margin-bottom:20px}.list-item-body[data-v-614be14b],.list-item-bottom[data-v-614be14b],.list-item-top[data-v-614be14b]{padding:10px 20px;color:#333}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-614be14b","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/listItemTpl.vue
// module id = 964
// module chunks = 23